// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wpxe","colBig":"styles_colBig__LhpOM","colSmall":"styles_colSmall__cZrhy"};